import { render, staticRenderFns } from "./EditableDiv.vue?vue&type=template&id=239f1bcc&"
import script from "./EditableDiv.vue?vue&type=script&lang=js&"
export * from "./EditableDiv.vue?vue&type=script&lang=js&"
import style0 from "./EditableDiv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports